<template>
  <!-- Footer -->
  <footer id="footer">
    <ul class="copyright">
    <!--
      This HTML theme is licensed under the CCA 3.0 license (html5up.net/license)
      DO NOT REMOVE THE ATTRIBUTION MESSAGE
    -->
    <li>&copy; D2SI - 2019</li><li>Design: <a href="http://html5up.net">HTML5 UP</a></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue